// ============================================================
// PASTE YOUR FIREBASE CONFIG HERE
// Same project as before — just copy from your existing config
// ============================================================
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
 apiKey: "AIzaSyAyRIYsQQZHC5Br-ZiS1up3UTW8UsA_q3Y",
  authDomain: "sandwich-chefs-catering.firebaseapp.com",
  projectId: "sandwich-chefs-catering",
  storageBucket: "sandwich-chefs-catering.firebasestorage.app",
  messagingSenderId: "362831378739",
  appId: "1:362831378739:web:a3db4921ec2bc062c96646"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
